import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EdocAddedBannerComponent } from './edoc-added-banner.component';

@NgModule({
  declarations: [EdocAddedBannerComponent],
  imports: [CommonModule],
  exports: [EdocAddedBannerComponent],
  bootstrap: [EdocAddedBannerComponent]
})
export class EdocAddedBannerModule {}
